export default __webpack_public_path__ + "static/media/runningshot.48ccba63.png";